<template>
    <div
            class="modal fade"
            id="sys_addtask_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">添加查表任务</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <ul class="nav nav-tabs">
                        <li class="active">
                            <a data-toggle="tab" href="#search-box">搜索选择</a>
                        </li>
                        <li>
                            <a data-toggle="tab" href="#layer-box">根据片区选择</a>
                        </li>
                    </ul>
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">任务批号:</label>
                            <div class="col-sm-4">
                                <input type="text" class="form-control" v-model="batch_no" placeholder="不输入默认为当前时间"/>
                            </div>
                            <label class="col-sm-2 control-label">任务说明 :</label>
                            <div class="col-sm-4">
                                <input type="text" class="form-control" v-model="description"/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-content">
                        <!--  -->
                        <div id="search-box" class="tab-pane active">
                            <div class="panel-body">
                                <div class="form-group">
                                    <label class="col-sm-2 control-label">基站名称：</label>
                                    <div class="col-sm-4">
                                        <input
                                                type="text"
                                                class="form-control"
                                                v-model="searchKey"
                                                placeholder="输入基站名称"
                                                @keyup.enter="searchFunc"
                                        />
                                    </div>
                                    <button class="btn btn-default" @click="searchFunc">搜索</button>
                                    <div class="form-group">
                                        <!-- 搜索出的基站列表 -->
                                        <div class="col-sm-6 search_ul">
                                            <li
                                                    :class="['search_li',item.choosen == true?'chosen_it':null]"
                                                    v-for="(item,index) in stationList"
                                                    :key="index"
                                                    @click="chooseIt(index,'search')"
                                            >{{item.stst_commname}} - {{item.stst_comm}} - {{item.stst_jtno}}
                                            </li>
                                        </div>
                                        <div class="col-sm-6 choose_ul">
                                            <li
                                                    class="search_li"
                                                    v-for="(item,index) in submitStation"
                                                    :key="index"
                                                    @click="removeStation(index)"
                                            >
                                                {{item.stst_commname}} - {{item.stst_comm}} - {{item.stst_jtno}}
                                                <i
                                                        class="fa fa-times remove_btn pull-right"
                                                ></i>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 根据片区筛选 -->
                        <div id="layer-box" class="tab-pane">
                            <div class="panel-body form-horizontal">
                                <div class="form-group">
                                    <label class="col-sm-2 control-label">片区:</label>
                                    <div class="col-sm-4">
                                        <select
                                                name
                                                class="layerchosen-select"
                                                style="width: 294px;"
                                                aria-placeholder="请选择片区"
                                        >
                                            <option value>请选择片区</option>
                                            <option
                                                    v-for="(item,index) in layerList"
                                                    :key="index"
                                                    :value="item.id"
                                            >{{item.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <!-- 00000 -->
                                <div class="form-group">
                                    <!-- 搜索出的基站列表 -->
                                    <div class="col-sm-6 search_ul">
                                        <li
                                                v-for="(item,index) in stationListByLayer"
                                                :class="['search_li',item.choosen == true?'chosen_it':null]"
                                                :key="index"
                                                @click="chooseIt(index,'layer')"
                                        >{{item.stst_commname}} - {{item.stst_comm}} - {{item.stst_jtno}}
                                        </li>
                                    </div>
                                    <div class="col-sm-6 choose_ul">
                                        <li
                                                class="search_li"
                                                v-for="(item,index) in submitStation"
                                                :key="index"
                                                @click="removeStation(index)"
                                        >
                                            {{item.stst_commname}} - {{item.stst_comm}} - {{item.stst_jtno}}
                                            <i
                                                    class="fa fa-times remove_btn pull-right"
                                            ></i>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--  -->
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        org_id: '', // 公司id
        layerid: '', // 片区id
        stationList: [], // 搜索出的基站列表
        stationListByLayer: [], // 根据片区筛选出的基站
        layerList: [],
        searchKey: '', // 搜索关键字
        submitStation: [], //被选中的基站
        batch_no: '', // 任务批号
        description: '' // 任务说明
      }
    },
    mounted: function () {
      var self = this
      var org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      self.org_id = org_id
      $('.layerchosen-select')
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: '100%'
        })
        .change(function () {
          self.stationList = []
          self.stationListByLayer = []
          self.layerid = $('.layerchosen-select').val()
          self.global.axiosGet(
            self,
            'layer/' + self.layerid + '/stations/',
            function (res) {
              // console.log("图层下的基站", res);
              // 默认为false 未被选选中
              for (var i = 0; i < res.length; i++) {
                res[i].choosen = false
              }
              self.stationListByLayer = res
              self.stationint()
            }
          )
        })
    },
    methods: {
      initFunc: function () {
        var self = this
        // 获取公司下所有片区
        self.global.axiosGet(self, 'layers/', function (res) {
          // console.log(res);
          self.layerList = res
          setTimeout(function () {
            $('.layerchosen-select').trigger('chosen:updated')
          }, 500)
        })
      },
      // 搜索基站
      searchFunc: function () {
        var self = this
        self.getstation('search=' + self.searchKey + '&org_id=' + self.org_id)
      },
      // 获取基站左侧列表初始化
      stationint: function () {
        var self = this
        for (var i = 0; i < self.stationList.length; i++) {
          for (var j = 0; j < self.submitStation.length; j++) {
            if (self.stationList[i].stst_atpid == self.submitStation[j].stst_atpid) {
              self.stationList[i].choosen = true
            }
          }
        }

        for (var i = 0; i < self.stationListByLayer.length; i++) {
          for (var j = 0; j < self.submitStation.length; j++) {
            if (self.stationListByLayer[i].stst_atpid == self.submitStation[j].stst_atpid) {
              self.stationListByLayer[i].choosen = true
            }
          }
        }
      },
      // 获取所有的基站
      getstation: function (param) {
        var self = this
        self.stationList = []
        self.stationListByLayer = []
        self.global.axiosGet(self, 'stations/?' + param, function (res) {
          //console.log("获取所有的基站", res.rows);
          for (var i = 0; i < res.rows.length; i++) {
            res.rows[i].choosen = false
          }
          self.stationList = res.rows
          self.stationint()
          // console.log(self.stationList);
        })
      },
      // 选择该基站
      chooseIt: function (index, type) {
        var self = this
        // console.log(type);
        // 已添加的在左侧列表变成灰色
        if (type == 'layer') {
          if (self.stationListByLayer[index].choosen == false) {
            self.stationListByLayer[index].choosen = true
          } else {
            alert('已选择该基站')
            return
          }
          self.submitStation.push(self.stationListByLayer[index])
        } else {
          if (self.stationList[index].choosen == false) {
            self.stationList[index].choosen = true
          } else {
            alert('已选择该基站')
            return
          }
          self.submitStation.push(self.stationList[index])
        }
      },
      // 在列表中移除该基站
      removeStation: function (index) {
        var self = this
        var id = self.submitStation[index].stst_atpid
        for (var i = 0; i < self.stationList.length; i++) {
          if (self.stationList[i].stst_atpid == id) {
            self.stationList[i].choosen = false
          }
        }
        for (var i = 0; i < self.stationListByLayer.length; i++) {
          if (self.stationListByLayer[i].stst_atpid == id) {
            self.stationListByLayer[i].choosen = false
          }
        }

        self.submitStation.splice(index, 1)
      },
      // 提交
      submit: function () {
        // batch_no (string) – 任务批号
        // type (string) – 任务类型[1 查表|2 巡检|3 维护]
        // source (string) – 任务来源[1 小程序|2 后台]
        // description (string) – 任务说明
        // station_list (jsonarr) – 基站列表
        var self = this
        var station_list = []
        for (var i = 0; i < self.submitStation.length; i++) {
          if (self.submitStation[i].station_id) {
            station_list.push(self.submitStation[i].station_id)
          } else {
            station_list.push(self.submitStation[i].id)
          }
        }
        self.batch_no.replace(/\s+/g, '') == ''
          ? (self.batch_no = new Date().toLocaleString('China', {
            hour12: false
          }))
          : null
        var tasksInfo = {
          batch_no: self.batch_no,
          type: 1,
          source: '2',
          description: self.description,
          station_list: station_list
        }
        self.global.axiosPost(self, 'tasks/', tasksInfo, function (res) {
          // console.log("/tasks/", res);
          if (res.status == 'success') {
            alert('提交成功')
            $('#ammetertask_atptable').bootstrapTable('refresh')
            $('#sys_addtask_modal').modal('hide')
          }
        })
      }
    }
  }
</script>
<style scoped>
    .search_ul {
        padding: 10px 20px;
    }

    .choose_ul {
        padding: 10px 20px;
    }

    .search_li {
        line-height: 3;
        list-style: none;
        border: 1px solid #dedede;
        border-top: none;
        text-indent: 20px;
    }

    .search_li:first-child {
        border: 1px solid #dedede;
    }

    .remove_btn {
        margin: 14px;
    }

    .chosen_it {
        color: #dedede;
    }
</style>



// WEBPACK FOOTER //
// src/views/lookammetertask/addammetertask.vue